var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_bin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "47_Shared-playlist",
    transform: "translate(-1348, -286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_bin",
    transform: "translate(1348, 286)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash-can",
    mask: "url(#mask-2)",
    fill: "#CFDAE6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5, 0)",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36322254,0 C8.87947499,0 9.37549462,0.205713845 9.74122943,0.57139287 C10.1061251,0.93765146 10.3115219,1.43468 10.3115219,1.95201181 L10.3115219,2.89625397 L10.4384597,3.02323809 L12.5137432,3.02399409 C12.7294961,3.02399409 12.9126317,3.181406 12.9470329,3.3925024 L12.9532024,3.47421415 C12.9527917,3.70691161 12.7560317,3.90402362 12.5137894,3.90402362 L12.3249981,3.904 L12.197998,4.03098604 L12.1981432,13.6699908 C12.1981432,14.2250931 12.0006313,14.7612496 11.6420361,15.1819753 L11.5134082,15.3211269 C11.0812985,15.7545898 10.4896931,16 9.87251959,16 L3.08068286,16 C2.46350933,16 1.8719039,15.7545898 1.43644565,15.3176362 C1.00008161,14.881208 0.755059273,14.2884224 0.755059273,13.6699889 L0.754188524,4.03097266 L0.627188423,3.904 L0.439397039,3.90402363 C0.22370635,3.90402362 0.0405707961,3.74661172 0.00616957799,3.53551532 L0,3.45380357 C0.000410746875,3.22110611 0.197170778,3.02399409 0.439413014,3.02399409 L2.51474272,3.02323809 L2.64168059,2.89625397 L2.64168059,1.95201181 C2.64168059,1.4934683 2.80312657,1.04934161 3.09647161,0.698003069 L3.21599555,0.567182126 C3.57770783,0.205713845 4.07372745,0 4.58997991,0 L8.36322254,0 Z M11.1931545,3.90402362 L1.76004794,3.90402362 L1.63306381,4.03100775 L1.63306381,13.6699889 C1.63306381,14.054809 1.78555266,14.4234533 2.05744774,14.6950068 C2.32828667,14.9671583 2.69639433,15.1199705 3.08068286,15.1199705 L9.87251959,15.1199705 C10.2568081,15.1199705 10.6249158,14.9671583 10.8960278,14.6947333 C11.1676498,14.4234533 11.3201386,14.054809 11.3201386,13.6699889 L11.3201386,4.03100775 L11.1931545,3.90402362 Z M4.58997991,6.42598745 C4.83222214,6.42598745 5.02898218,6.62309947 5.02898218,6.86600221 L5.02898218,12.1579919 C5.02898218,12.4008946 4.83222214,12.5980066 4.58997991,12.5980066 C4.34773767,12.5980066 4.15097764,12.4008946 4.15097764,12.1579919 L4.15097764,6.86600221 C4.15097764,6.62309947 4.34773767,6.42598745 4.58997991,6.42598745 Z M8.36322254,6.42598745 C8.60546477,6.42598745 8.80222481,6.62309947 8.80222481,6.86600221 L8.80222481,12.1579919 C8.80222481,12.4008946 8.60546477,12.5980066 8.36322254,12.5980066 C8.1209803,12.5980066 7.92422027,12.4008946 7.92422027,12.1579919 L7.92422027,6.86600221 C7.92422027,6.62309947 8.1209803,6.42598745 8.36322254,6.42598745 Z M8.36322254,0.880029531 L4.58997991,0.880029531 C4.30624277,0.880029531 4.03464564,0.992849956 3.83319055,1.19380664 C3.63225389,1.39596136 3.51968512,1.66792309 3.51968512,1.95201181 L3.51968512,2.89700997 L3.64666925,3.02399409 L9.3065332,3.02399409 L9.43351732,2.89700997 L9.43351732,1.95201181 C9.43351732,1.66792309 9.32094855,1.39596136 9.12039446,1.19418988 C8.91855681,0.992849956 8.64695968,0.880029531 8.36322254,0.880029531 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBin);
export default __webpack_public_path__ + "static/media/ic_bin.fe3e9b5693880ad22b96c516daa06096.svg";
export { ForwardRef as ReactComponent };